import React from 'react'
import { MIN_SPACING, MAX_SPACING, type Shape } from 'types/shapes'
import ContextualMenu from 'components/graph/controls/contextualMenu'
import AddShapeControl from 'components/graph/controls/addShapeControl'
import AddToShapeControl from 'components/graph/controls/addToShapeControl'
import MoveEntityControl from 'components/graph/controls/moveEntityControl'
import RemoveFromShapeControl from 'components/graph/controls/removeFromShapeControl'
import RemoveShapeControl from 'components/graph/controls/removeShapeControl'
import ToggleShapeDirectionControl from 'components/graph/controls/toggleShapeDirectionControl'
import SpacingControl from 'components/graph/controls/spacingControl'

type ShapeMenuProps = {
  open: boolean
  onCollapse: () => void
  focusId: string
  shape: Shape | null
  isAdding: boolean
  onAddShape: () => void
  onStartAddToShape: () => void
  onCancelAddToShape: () => void
  onRemoveShape: () => void
  onMoveEntity: (direction: 'left' | 'right') => void
  onRemoveFromShape: () => void
  onToggleDirection: () => void
  onAdjustSpacing: (mode: 'expand' | 'contract') => void
  onWidthChange?: (width: number) => void
}

const ShapeMenu = ({
  open,
  onCollapse,
  focusId,
  shape,
  isAdding,
  onAddShape,
  onStartAddToShape,
  onCancelAddToShape,
  onRemoveShape,
  onMoveEntity,
  onRemoveFromShape,
  onToggleDirection,
  onAdjustSpacing,
  onWidthChange,
}: ShapeMenuProps) => {
  const entityIndex = shape ? shape.entityIds.indexOf(focusId) : -1
  const isListMember = shape?.shapeType === 'list' && entityIndex !== -1
  const canMoveLeft = isListMember && entityIndex > 0
  const canMoveRight = isListMember && shape != null && entityIndex < shape.entityIds.length - 1
  const canRemoveFromShape = shape != null && shape.entityIds.length > 1
  const spacing = shape?.settings.spacing ?? 0
  const canContractSpacing = shape != null && spacing > MIN_SPACING
  const canExpandSpacing = shape != null && spacing < MAX_SPACING

  return (
    <ContextualMenu open={open} onCollapse={onCollapse} onWidthChange={onWidthChange}>
      {!shape ? <AddShapeControl onClick={onAddShape} /> : null}
      {shape ? <AddToShapeControl active={isAdding} onStart={onStartAddToShape} onCancel={onCancelAddToShape} /> : null}
      {shape ? <ToggleShapeDirectionControl direction={shape.settings.direction} onClick={onToggleDirection} disabled={isAdding} /> : null}
      {shape ? <SpacingControl mode="contract" direction={shape.settings.direction} onClick={() => onAdjustSpacing('contract')} disabled={isAdding || !canContractSpacing} /> : null}
      {shape ? <SpacingControl mode="expand" direction={shape.settings.direction} onClick={() => onAdjustSpacing('expand')} disabled={isAdding || !canExpandSpacing} /> : null}
      {canMoveLeft ? <MoveEntityControl direction="left" onClick={() => onMoveEntity('left')} disabled={isAdding} /> : null}
      {canMoveRight ? <MoveEntityControl direction="right" onClick={() => onMoveEntity('right')} disabled={isAdding} /> : null}
      {canRemoveFromShape ? <RemoveFromShapeControl onClick={onRemoveFromShape} disabled={isAdding} /> : null}
      {shape ? <RemoveShapeControl onClick={onRemoveShape} disabled={isAdding} /> : null}
    </ContextualMenu>
  )
}

export default ShapeMenu
